import { computed, reactive } from 'vue';
import { inputToCents } from '@cta/frontend/javascripts/money';

export const addressStepAttributes = [
  'salutation',
  'firstname',
  'lastname',
  'street',
  'countrycode',
  'postalcode',
  'region',
  'locality',
  'emailaddress',
];

export const paymentStepAttributes = [
  'paymentType',
  'owner',
  'iban',
  'adyenData',
];

export const store = reactive({
  openStep: 'amount',
  amountStepOpen: computed(() => store.openStep === 'amount'),
  addressStepOpen: computed(() => store.openStep === 'address'),
  paymentStepOpen: computed(() => store.openStep === 'payment'),
  errors: {
    amount: undefined,
    firstname: undefined,
    lastname: undefined,
    street: undefined,
    postalcode: undefined,
    region: undefined,
    locality: undefined,
    emailaddress: undefined,
    paymentType: undefined,
    owner: undefined,
    iban: undefined,
    adyenData: undefined,
  },
  values: {
    amount: undefined,
    salutation: undefined,
    firstname: undefined,
    lastname: undefined,
    street: undefined,
    countrycode: undefined,
    postalcode: undefined,
    region: undefined,
    locality: undefined,
    emailaddress: undefined,
    paymentType: undefined,
    owner: undefined,
    iban: undefined,
    rawIban: undefined,
    adyenData: undefined,
    allowPrefillBankAccount: undefined,
    switchToRecurringDonation: undefined,
  },
  amountStepValid: computed(() => store.errors.amount === undefined),
  amountErrorUnlocked: false,
  setAmount: (newAmount) => {
    store.values.amount = newAmount;
  },
  addressStepValid: computed(() => addressStepAttributes.every((name) => store.errors[name] === undefined)),
  addressErrorUnlocked: false,
  addressPrefilled: undefined,
  paymentStepValid: computed(() => paymentStepAttributes.every((name) => store.errors[name] === undefined)),
  paymentErrorUnlocked: false,
  paymentPrefilled: undefined,
});

export default function initializeStore(defaults) {
  store.values.amount = defaults.amountPrefill ? inputToCents(defaults.amountPrefill) : undefined;
  store.values.salutation = defaults.collectAddress
    ? (defaults.prefilledAttributes.salutation || defaults.defaultSalutation)
    : undefined;
  store.values.firstname = defaults.prefilledAttributes.firstname;
  store.values.lastname = defaults.prefilledAttributes.lastname;
  store.values.street = defaults.collectAddress ? defaults.prefilledAttributes.street : undefined;
  store.values.locality = defaults.collectAddress ? defaults.prefilledAttributes.locality : undefined;
  store.values.postalcode = defaults.collectAddress ? defaults.prefilledAttributes.postalcode : undefined;
  store.values.region = defaults.collectAddress ? defaults.prefilledAttributes.region : undefined;
  store.values.countrycode = defaults.collectAddress
    ? (defaults.prefilledAttributes.countrycode || defaults.defaultCountryCode)
    : undefined;
  store.values.emailaddress = defaults.prefilledAttributes.emailaddress;
  store.values.paymentType = defaults.paymentTypes.includes(defaults.prefilledAttributes.paymentType)
    ? defaults.prefilledAttributes.paymentType
    : undefined;
  store.values.owner = defaults.prefilledAttributes.owner;
  store.values.iban = defaults.prefilledAttributes.iban;
  store.values.rawIban = defaults.prefilledAttributes.iban;

  store.addressPrefilled = addressStepAttributes.some((name) => defaults.prefilledAttributes[name] !== undefined);
  store.paymentPrefilled = defaults.prefilledAttributes['owner'] !== undefined || defaults.prefilledAttributes['iban'] !== undefined;

  store.values.switchToRecurringDonation = defaults.recurringDonationOfferOnetimeButtonPreselected === true ? false : undefined;

  return store;
}
